<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<filter-subscription v-model="filter" :customers="customers" :memberships="memberships" @filter="onFilter()"></filter-subscription>
			</v-flex>
			<v-flex xs12>
				<app-datatable :title="$t('title.subscriptions_datatable')" :printUrl="$route('central.subscriptions.print.subscriptions', {
					params: {},
				})
					" :endpoint="endpoint" :data="data" :headers="headers" :filter="filter" @onPrint="printItem" @onEdit="editItem" @onDelete="deleteItem" @onView="viewItem" :hasView="$gates.hasAnyPermission('view subscriptions')"
					:hasEdit="$gates.hasAnyPermission('edit subscriptions')" :hasDelete="$gates.hasAnyPermission('delete subscriptions')">
					<template v-slot:[`item.state`]="{ item }">
						<v-chip :color="item.state_color" dark>
							{{ item.state_label }}
						</v-chip>
						<br />
						<template v-if="item.state == 'expired'">
							<v-btn v-if="!item.child_code" text small :href="$route('central.subscriptions.renew', {
								subscription: item.uuid,
							})"><small style="text-align: center;">Renew</small></v-btn>
							<small v-else>Renewed: {{ item.child_code }}</small>
						</template>

					</template>
					<template v-slot:[`item.coverage`]="{ item }">
						{{ item.formatted_start_date }} - {{ item.formatted_end_date }}
					</template>
					<template v-slot:[`item.image`]="{ item }">
						<img :src="item.image_url" :lazy-src="item.image_url" :aspect-ratio="4 / 3" style="width: 100px; height: auto" />
					</template>
					<template v-slot:[`item.status`]="{ item }">
						<v-chip :color="item.payment_status_color" dark small>
							{{ item.payment_status_label }}
						</v-chip>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>

		<app-create-fab-button v-permission="'create subscriptions'" @click="$inertia.visit($route('central.subscriptions.create'))"></app-create-fab-button>

		<app-delete-dialog ref="deleteDialog" :endpoint="'central.subscriptions.destroy'" :uuid="item.uuid"></app-delete-dialog>
	</v-container>
</template>

<script>
	import pickBy from "lodash/pickBy";
	export default {
		props: ["data", "customers", "memberships"],
		data() {
			return {
				filter: {},
				item: {},
			};
		},
		computed: {
			endpoint() {
				return this.$route("central.subscriptions.index");
			},
			headers() {
				return [
					{
						text: this.$t("Action"),
						value: "actions",
						sortable: false,
						searchable: false,
						align: "left",
						width: 80,
					},
					{
						text: this.$t("Image"),
						value: "image",
						sortable: false,
						searchable: false,
						width: 80,
					},
					{
						text: this.$t("Coverage"),
						value: "coverage",
						align: "start",
						sortable: false,
					},
					{
						text: this.$t("Code"),
						value: "code",
						align: "start",
						sortable: false,
					},
					{
						text: this.$t("Customer"),
						value: "customer.display_name",
						sortable: false,
						searchable: false,
					},
					{
						text: this.$t("Membership"),
						value: "membership.name",
						sortable: false,
						searchable: false,
					},
					{
						text: this.$t("label.state"),
						value: "state",
						sortable: false,
						searchable: false,
						align: 'center',
					},
					{
						text: this.$t("Payment Method"),
						value: "payment_method_code",
						sortable: false,
						searchable: false,
					},
					{
						text: this.$t("Status"),
						value: "status",
						sortable: false,
						searchable: false,
						align: "end",
					},
				];
			},
		},

		methods: {
			onFilter() {
				var filter = pickBy(this.filter);
				this.$inertia.get(
					this.endpoint,
					{ filter },
					{
						preserveState: true,
						preserveScroll: true,
					}
				);
			},
			editItem(item) {
				this.$inertia.get(
					this.$route("central.subscriptions.edit", item.uuid)
				);
			},

			viewItem(item) {
				this.$inertia.get(
					this.$route("central.subscriptions.show", item.uuid)
				);
			},
			deleteItem(item) {
				this.item = Object.assign({}, item);
				this.$refs.deleteDialog.open();
			},
			printItem(item) {
				window.open(
					this.$route("central.print.subscription", {
						subscription: item.uuid,
					})
				);
			},
		},
	};
</script>